// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import transformContentHtml from "@insite/client-framework/Common/Utilities/transformContentHtml";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import parse from "html-react-parser";
// import * as React from "react"; // Starter Custom Code
import { css } from "styled-components";

/* Starter Custom Code - Start */
import translate from "@insite/client-framework/Translate";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { linkActionStyles } from "@store/Themes/common/mixins/link";
import { lineEllipsisStyles } from "@store/Themes/common/mixins/typography";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import scrollToId from "@toolkit/Framework/Common/Utilities/scrollToId";
import stripHtml from "@toolkit/Framework/Common/Utilities/stripHtml";
import setIsAccordionOpen from "@toolkit/Framework/Store/Toolkit/Components/Accordion/Handlers/SetIsAccordionOpen";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React from "react";
import { useDispatch } from "react-redux";

const enum fields {
    shortDescription = "shortDescription",
    anchor = "anchor",
}
/* Starter Custom Code - End */

// Foundation --->
import useParentProductState from "@store/Framework/Store/Foundation/Data/Products/ProductsHooks/useParentProductState";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
// <--- Foundation

type Props = WidgetProps & HasProduct;

export interface ProductDetailsDescriptionStyles {
    wrapper?: InjectableCss;
    // Starter Custom Code
    noResult?: TypographyPresentationProps;
    shortDescriptionWrapper?: InjectableCss;
    shortDescription?: InjectableCss;
    productReadMoreLink?: LinkPresentationProps;
}

const maxLine = 3;

export const descriptionStyles: ProductDetailsDescriptionStyles = {
    // Foundation --->
    wrapper: {
        css: css`
            margin-bottom: ${pxToRem(15)};
        `,
    },
    // <--- Foundation
    noResult: {
        forwardAs: "p",
    },
    shortDescriptionWrapper: {
        css: css`
            ${({ theme }) => {
                const spacing = theme.design.product.detail.contentSpacing;
                return spacingStyles(spacing, spacing);
            }}

            ${breakpoint("sm", "down")} {
                display: none;
            }
        `,
    },
    shortDescription: {
        css: css`
            ${lineEllipsisStyles(maxLine)}
            ${({ theme }) => {
                const fontSize = theme.design.typography.size.smaller;
                const lineHeight = theme.design.typography.lineHeight.base;

                return css`
                    font-size: ${fontSize};
                    line-height: ${lineHeight};
                    max-height: calc((${lineHeight} * ${fontSize}) * ${maxLine});
                `;
            }}
        `,
    },
    productReadMoreLink: {
        css: css`
            ${linkActionStyles()}
            ${spacingStyles("0.125em", null)}
            display: flex;
        `,
    },
};

const styles = descriptionStyles;

const ProductDetailsDescription: React.FC<Props> = ({
    product,
    // Starter Custom Code
    fields: { shortDescription, anchor },
}) => {
    /* Starter Custom Code - Start */
    const dispatch = useDispatch();
    // Foundation --->
    const parentProductState = useParentProductState();
    // <--- Foundation

    if (!product.content?.htmlContent) {
        return null;
    }

    const anchorHandler = () => {
        scrollToId(anchor);
        dispatch(setIsAccordionOpen({ id: anchor, isOpen: true }));
    };
    return (
        <StyledWrapper {...styles.wrapper}>
            <div data-test-selector="productDetails_htmlContent">
                {/* Foundation ---> */}
                {product.content?.htmlContent
                    ? parse(product.content.htmlContent, parserOptions)
                    : parentProductState?.content?.htmlContent
                    ? parse(parentProductState?.content?.htmlContent, parserOptions)
                    : translate("No description available")}
                {/* <--- Foundation */}
            </div>
        </StyledWrapper>
    );
    /* Starter Custom Code - End */
};

const widgetModule: WidgetModule = {
    component: withProduct(ProductDetailsDescription),
    definition: {
        displayName: "Description",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
        // Foundation Removed Code
    },
};

export default widgetModule;
